import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { format, addDays } from "date-fns";
import HelmetWrapper from "../../../HelmetWrapper";
import CommonStructured from "../../common-components/CommonStructured";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import { fetchCartPendingPaymentsData } from "../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../PaymentLinkTable";
import {
  convertThenFormat,
  formatTimezoneThenStraight,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { BodyBuilder } from "../../../exports/Images";
import CartHistoryMobile from "./CartHistoryMobile";
import PlanDetailsMobile from "./PlanDetailsMobile";
import AgentInfoMobile from "./AgentInfoMobile";

const CartHistoryCommon = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";
  const isManagerRole = ["fitness_manager", "sales_manager", "club_manager"].includes(userInfoData?.account_type);

  const { cartPendingPaymentsLoading, cartPendingPayments } = useSelector(
    (state) => state.api
  );

  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isMarketing && !isClusterManager && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStatus: "",
    selectedPlan: "",
    selectedReceptionist: "",
    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    status: allFilters.selectedStatus?.value || "",
    gym_id: !isAdmin && !isMarketing && !isClusterManager && !isManagerRole
      ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid
      : allFilters.selectedGym?.value || "",
    duration: allFilters.selectedPlan?.label || "",
    agent_id: allFilters.selectedReceptionist
      ? allFilters.selectedReceptionist?.value
      : "",
    date_from: allFilters.selectedStartDate || "",
    date_to: allFilters.selectedEndDate || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const iniPTDatas = {
    allPendingPayments: [],
    pagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    isModOpen2: false,
    isModOpen3: false,
    cardName: "",
    cardName2: "",
    cardName3: "",
    rowData: "",
    rowData2: "",
    rowData3: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
    setIsPage(0);
  }

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  function onCloseModalvalues1() {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen2: false,
      cardName2: "",
      rowData2: [],
    }));
  }

  function onCloseModalvalues2() {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen3: false,
      cardName3: "",
      rowData3: [],
    }));
  }

  const onClickSearch = () => {
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
      setIsPage(0);
    }
  };

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  function getCartPendingPayments(filters) {
    dispatch(
      fetchCartPendingPaymentsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: !isAdmin && !isClusterManager && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    }));
  }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      status: allFilters.selectedStatus?.value || "",
      gym_id: !isAdmin && !isClusterManager && !isManagerRole
        ? userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid
        : allFilters.selectedGym?.value || "",
      duration: allFilters.selectedPlan?.value || "",
      agent_id: allFilters.selectedReceptionist
        ? allFilters.selectedReceptionist?.value
        : "",
      date_from: allFilters.selectedStartDate || "",
      date_to: allFilters.selectedEndDate || "",
    }));
  }, [
    isPage,
    allFilters.selectedGym,
    allFilters.selectedStatus,
    allFilters.selectedReceptionist,
    allFilters.selectedPlan,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
  ]);

  useEffect(() => {
    if (cartPendingPayments?.status && cartPendingPayments?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allPendingPayments: cartPendingPayments.data,
        pagination: cartPendingPayments.pagination,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allPendingPayments: [],
        pagination: [],
      }));
    }
  }, [cartPendingPayments]);

  useEffect(() => {
    getCartPendingPayments(filters);
  }, [filters]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "name",
      text: "member info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.name || "NA"}
            <br />
            <small>{row?.mobile || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "agent_name",
      text: "agent",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.agent_name || "NA"}
            <br />
            <small
              style={{
                textTransform: "lowercase",
              }}
            >
              {row?.agent_mobile || ""}
              <br />
              {row?.agent_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "req_body",
      text: "plan detail",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "plan_details",
                rowData: [row?.req_body] || [],
              }));
            }}
          >
            view
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "completed" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "completed" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatTimezoneThenStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  const tbColumnsPlanDetails = [
    {
      dataField: "type",
      text: "type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type || "NA"}</span>;
      },
    },
    {
      dataField: "price",
      text: "price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
        );
      },
    },
    {
      dataField: "tax_amount",
      text: "tax amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.tax_amount || 0)} (
            {row?.tax_percentage || 0})%
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "plan duration",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.start_date ? row.start_date : "-"} TO{" "}
            {row?.expire_date ? row.expire_date : "-"}
          </span>
        );
      },
    },
    {
      dataField: "lead_source",
      text: "lead source",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.lead_source?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "coupon",
      text: "coupon",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.coupon || "NA"}</span>;
      },
    },
    {
      dataField: "receptionist_data",
      text: "agent info",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              row?.receptionist_data &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen2: true,
                  cardName2: "agent_info",
                  rowData2: row?.receptionist_data || [],
                }));
            }}
            style={{
              opacity: row?.receptionist_data ? "1" : "0.5",
              cursor: row?.receptionist_data ? "pointer" : "not-allowed",
            }}
          >
            view
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "partial detail",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              row?.is_partial &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen2: true,
                  cardName2: "partial_details",
                  rowData2: row?.partial_details || [],
                }));
            }}
            style={{
              opacity: row?.is_partial ? "1" : "0.5",
              cursor: row?.is_partial ? "pointer" : "not-allowed",
            }}
          >
            view
          </span>
        );
      },
    },
    {
      dataField: "package_data",
      text: "package data",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              row?.package_data &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen2: true,
                  cardName2: "package_data",
                  rowData2: [row?.package_data] || [],
                }));
            }}
            style={{
              opacity: row?.package_data ? "1" : "0.5",
              cursor: row?.package_data ? "pointer" : "not-allowed",
            }}
          >
            view
          </span>
        );
      },
    },
  ];

  const tbColumnsAI = [
    {
      dataField: "profile",
      text: "agent Profile",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.profile || BodyBuilder}
              alt={row?.name || "NA"}
              className="image"
              style={{
                height: "100px",
                width: "100px",
                objectFit: "contain",
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: "agent name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    {
      dataField: "mobile",
      text: "agent mobile",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.mobile || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
  ];

  const tbColumnsPartialDetails = [
    {
      dataField: "online_amount",
      text: "online amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.online_amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "cash_amount",
      text: "cash amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.cash_amount || 0)}
          </span>
        );
      },
    },
  ];

  const tbColumnsPackageData = [
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || 0}</span>;
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.duration || 0} days</span>;
      },
    },
    {
      dataField: "base_price",
      text: "base price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.base_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "original_price",
      text: "original price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.original_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "plan_price",
      text: "plan price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.plan_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "processing_fee",
      text: "processing fee",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.processing_fee || 0}</span>;
      },
    },
    {
      dataField: "first_emi_percentage",
      text: "first EMI",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">{row?.first_emi_percentage || 0}%</span>
        );
      },
    },
    {
      dataField: "second_emi_percentage",
      text: "second EMI",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.second_emi_percentage || 0}% in{" "}
            {row?.second_emi_duration || 0} days
          </span>
        );
      },
    },
    {
      dataField: "third_emi_percentage",
      text: "third EMI",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.third_emi_percentage || 0}% in {row?.third_emi_duration || 0}{" "}
            days
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data"
            dangerouslySetInnerHTML={{
              __html: row?.description || "No Content Available",
            }}
          ></span>
        );
      },
    },
    {
      dataField: "plan_features",
      text: "plan features",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              row?.plan_features &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen3: true,
                  cardName3: "plan_features",
                  rowData3: row?.plan_features || [],
                }));
            }}
            style={{
              opacity: row?.plan_features ? "1" : "0.5",
              cursor: row?.plan_features ? "pointer" : "not-allowed",
            }}
          >
            view
          </span>
        );
      },
    },
    {
      dataField: "price_details",
      text: "price details",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              row?.price_details &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen3: true,
                  cardName3: "price_details",
                  rowData3: row?.price_details || [],
                }));
            }}
            style={{
              opacity: row?.price_details ? "1" : "0.5",
              cursor: row?.price_details ? "pointer" : "not-allowed",
            }}
          >
            view
          </span>
        );
      },
    },
  ];

  const tbColumnsPlanFeatures = [
    {
      dataField: "feature_name",
      text: "feature name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.feature_name || "NA"}</span>;
      },
    },
  ];

  const tbColumnsPriceDetails = [
    {
      dataField: "type",
      text: "type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type || "NA"}</span>;
      },
    },
    {
      dataField: "plan_price",
      text: "plan price",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.plan_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Membership Cart History">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModalvalues}
          contentLabel="Cart History"
          ariaHideApp={false}
        >
          <div className={`createNewCTOModalContainer`}>
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues}
            />

            {modValues.cardName === "plan_details" ? (
              <>
                <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
                  <PaymentLinkTable
                    tableData={modValues.rowData}
                    tableColumns={tbColumnsPlanDetails}
                  />
                </div>

                <div className="lead-logs-card-container only-mobile">
                  <PlanDetailsMobile
                    tableData={modValues.rowData}
                    setModValues={setModValues}
                  />
                </div>
              </>
            ) : null}
          </div>
        </Modal>

        <Modal
          isOpen={modValues.isModOpen2}
          onRequestClose={onCloseModalvalues1}
          contentLabel="Cart History"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName2 !== "package_data" ? "mod-width-50p" : ""
            }`}
          >
            <ModalHeadAndClose
              title={`${modValues.cardName2?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues1}
            />

            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
              <PaymentLinkTable
                tableData={modValues.rowData2}
                tableColumns={
                  modValues.cardName2 === "agent_info"
                    ? tbColumnsAI
                    : modValues.cardName2 === "partial_details"
                    ? tbColumnsPartialDetails
                    : modValues.cardName2 === "package_data"
                    ? tbColumnsPackageData
                    : []
                }
              />
            </div>

            <div className="lead-logs-card-container only-mobile">
              <AgentInfoMobile
                tableData={modValues.rowData2}
                setModValues={setModValues}
                cardName={modValues.cardName2}
              />
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modValues.isModOpen3}
          onRequestClose={onCloseModalvalues2}
          contentLabel="Cart History"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.cardName3 !== "package_data" ? "mod-width-50p" : ""
            }`}
          >
            <ModalHeadAndClose
              title={`${modValues.cardName3?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues2}
            />

            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
              <PaymentLinkTable
                tableData={modValues.rowData3}
                tableColumns={
                  modValues.cardName3 === "plan_features"
                    ? tbColumnsPlanFeatures
                    : modValues.cardName3 === "price_details"
                    ? tbColumnsPriceDetails
                    : []
                }
              />
            </div>

            <div className="lead-logs-card-container only-mobile">
              <AgentInfoMobile
                tableData={modValues.rowData3}
                setModValues={setModValues}
                cardName={modValues.cardName3}
              />
            </div>
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured pageHeading={"Membership Cart History"} />
          </Col>
        </Row>

        <Row>
          <Col>
            <CommonFilterStructure
              from={"cart-history"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              openDateRanger={openDateRanger}
              handleDateRangeChange={handleDateRangeChange}
              setOpenDateRanger={setOpenDateRanger}
              rangeState={rangeState}
              clearDateRanger={clearDateRanger}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile mt30">
              {cartPendingPaymentsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allPendingPayments}
                  tableColumns={tbColumns}
                  tablePagination={
                    allDatas.pagination?.length > 0 ? allDatas.pagination : []
                  }
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>

            <div className="lead-logs-card-container only-mobile">
              <CartHistoryMobile
                tableData={allDatas.allPendingPayments}
                tablePagination={
                  allDatas.pagination?.length > 0 ? allDatas.pagination : []
                }
                isPage={isPage}
                setIsPage={setIsPage}
                setModValues={setModValues}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CartHistoryCommon;
